import cepPromise from "cep-promise";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import Select from "../../../components/Select/Select";
import UploadButton from "../../../components/UploadButton/UploadButton";
import { useListManager } from "../../../contexts/list.manager";
import removeMask from "../../../functions/RemoveMask";
import ClientService from "../../../services/ClientService";
import ImagesService from "../../../services/ImagesService";
import "./FormClients.css";
import ToolTip from "../../../components/Tooltip/Tooltip";
import ResponsibleList from "../../../components/ResponsibleList/ResponsibleList";
import ResponsibleModal from "./ResponsibleModal";
import Action from "../../AccessManagementCloud/Policies/FormPoliticas/Action";
import { MdOutlineDelete } from "react-icons/md";
import Button from "../../../components/Button/Button";
import { BiReset } from "react-icons/bi";
import { defaultOrganizationActions } from "../../../policy-engine/utils/default-organization-actions";
import { Buffer } from "buffer";
import { BsPeople } from "react-icons/bs";

function FormClients(props) {
	const [nome, setNome] = useState(props.client?.name);
	const [status, setStatus] = useState(props.client?.status);
	const [cpfOrCnpj, setCpfOrCnpj] = useState(props.client?.document || "");
	const [bairro, setBairro] = useState(props.client?.address?.district);
	const [rua, setRua] = useState(props.client?.address?.streetName);
	const [numero, setNumero] = useState(props.client?.address?.streetNumber);
	const [complemento, setComplemento] = useState(props.client?.address?.complement);
	const [cidade, setCidade] = useState(props.client?.address?.city);
	const [uf, setUf] = useState(props.client?.address?.uf);
	const [pais, setPais] = useState(props.client?.address?.country);
	const [telefone, setTelefone] = useState(props.client?.phone);
	const [mail, setMail] = useState(props.client?.email);
	const [site, setSite] = useState(props.client?.site);
	const [responsibles, setResponsibles] = useState([]);
	const [showRespModal, setShowRespModal] = useState(false);
	const [observacao, setObservacao] = useState(props.client?.comment);
	const [tema, setTema] = useState(props.client?.theme);
	const [showLoader, setShowLoader] = useState(false);
	const [urlLogo, setUrlLogo] = useState(props.client?.urlLogo);
	const [photoFile, setPhotoFile] = useState();
	const [currentPhotoFile, setCurrentPhotoFile] = useState();
	const [actions, setActions] = useState([]);
	const [showPermissions, setShowPermissions] = useState(false);
	const [cep, setCep] = useState(props.client?.cep);
	const [primaryColor, setPrimaryColor] = useState(props.client?.primaryColor || "");
	const [secondaryColor, setSecondaryColor] = useState(props.client?.secondaryColor || "");

	const { closeForm } = useListManager();

	async function loadCurrentPhotoFile() {
		if (!props.client?.urlLogo) return;
		const response = await ImagesService.getImage(props.client?.urlLogo);
		if (!response.data) return;
		const responseImage = await ImagesService.getRawImage(response.data.replace("[:STORAGE_ADDRESS:]", window.location.hostname));
		const binaryData = responseImage.data;
		const base64Data = new Buffer.from(binaryData, "binary").toString(
			"base64",
		);
		const originalDataUrl = `data:image/png;base64,${base64Data}`;
		setCurrentPhotoFile(originalDataUrl);
	}

	useEffect(() => {
		setNome(props.client?.name);
		setStatus(props.client?.status);
		setCpfOrCnpj(props.client?.document || "");
		setBairro(props.client?.address?.district);
		setRua(props.client?.address?.streetName);
		setNumero(props.client?.address?.streetNumber);
		setComplemento(props.client?.address?.complement);
		setCidade(props.client?.address?.city);
		setUf(props.client?.address?.state);
		setPais(props.client?.address?.country);
		setTelefone(props.client?.phone);
		setMail(props.client?.email);
		setSite(props.client?.site);
		setResponsibles(props.client?.responsibles || []);
		setObservacao(props.client?.annotation);
		setTema(props.client?.theme);
		setUrlLogo(props.client?.urlLogo);
		setCep(props.client?.address?.postalCode);
		setPrimaryColor(props.client?.primaryColor);
		setSecondaryColor(props.client?.secondaryColor);
		setActions(props.client?.allowedActions?.map((actionItem) => {
			const [owner, service, scope, action] = actionItem.split('.');
			return {
				owner,
				service,
				scope,
				action
			}
		}) ?? []);
		if (props.client?.urlLogo) {
			loadCurrentPhotoFile();
		}
	}, [props.client]);

	const navigate = useNavigate();

	const buildPayload = (urlFromResponse) => {
		const processedResponsibles = responsibles.map(resp => {
			let newResp = { ...resp };
			// Check if email field contains '@', otherwise treat as phone
			if (newResp.email && !newResp.email.includes('@')) {
				newResp.phone = newResp.email;
				delete newResp.email;
			}
			return newResp;
		});

		let payload = {
			name: nome,
			status: parseInt(status),
			document: removeMask(cpfOrCnpj),
			phone: removeMask(telefone),
			email: mail,
			site: site,
			annotation: observacao,
			defaultTheme: tema,
			urlLogo: urlFromResponse ?? urlLogo,
			allowedActions: actions.map(action => `${action.owner}.${action.service}.${action.scope}.${action.action}`),
			primaryColor,
			secondaryColor,
			address: {
				id: props.client?.address?.id,
				district: bairro,
				streetName: rua,
				streetNumber: Number(numero),
				complement: complemento,
				city: cidade,
				state: uf,
				country: pais,
				postalCode: removeMask(cep),
			},
			responsibles: processedResponsibles,
		};
		return payload;
	};

	async function handlePhotoSubmission() {
		let newUrl = null;
		if (photoFile) {
			const formData = new FormData();
			formData.append("file", photoFile);
			formData.append("entity", "organization");
			formData.append("organizationExternalId", props.client?.externalId);
			const response = await ImagesService.storeImage(formData);
			return response.data.payload.id;
		}
		return newUrl;
	}

	async function handleSubmit(event) {
		event.preventDefault();
		setShowLoader(true);
		const urlFromResponse = await handlePhotoSubmission();
		const payload = buildPayload(urlFromResponse);
		let response = {};
		if (props.type === "edicao") {
			response = await ClientService.updateClient(props.client.id, payload);
		}
		if (props.type === "cadastro") {
			response = await ClientService.createClient(payload);
		}
		setShowLoader(false);
		if (!response.data.id) return;
		navigate("../consulta-clientes", { replace: true, state: {} });
	}

	async function handleDelete() {
		setShowLoader(true);
		if (!props.client) return;
		await ClientService.deleteClient(props.client.id);
		navigate("../consulta-clientes", {
			replace: true, state: {},
		});
		setShowLoader(false);
		closeForm();
	}

	const handleClickEditButton = () => {
		if (!props.client) return;
		navigate("/cadastro-clientes", { state: props.client });
	};

	const handleCepBlur = (cepValue) => {
		const digits = cepValue.replace(/\D/g, "");
		if (cepValue && digits.length === 8) {
			cepPromise(cepValue)
				.then((result) => {
					setBairro(result.neighborhood || "");
					setRua(result.street || "");
					setCidade(result.city || "");
					setUf(result.state || "");
					setPais("Brasil");
				})
				.catch((error) => {
					console.error("CEP inválido ou não encontrado:", error);
				});
		}
	};

	function addAction() {
		setActions(actions => {
			return [...actions, { owner: 'bravas' }];
		});
	}

	function removeAction(idx) {
		const act = [
			...actions.slice(0, idx),
			...actions.slice(idx + 1)
		];
		setActions([...act])
	}

	function updateActionField(idx, field, value) {
		const actionIdx = actions.findIndex((action, key) => key === idx)
		actions[actionIdx][field] = value;
		if (['owner'].includes(field)) {
			actions[actionIdx]['service'] = 0;
			if (value === '*') {
				actions[actionIdx]['service'] = '*';
			}
		}
		if (['owner', 'service'].includes(field)) {
			actions[actionIdx]['scope'] = 0;
			if (value === '*') {
				actions[actionIdx]['scope'] = '*';
			}
		}
		if (['owner', 'service', 'scope'].includes(field)) {
			actions[actionIdx]['action'] = 0;
			if (value === '*') {
				actions[actionIdx]['action'] = '*';
			}
		}
		setActions([...actions])
	}

	function defaultActions() {
		setActions(defaultOrganizationActions);
	}

	function handleAddResponsible(resp) {
		if (responsibles.find(responsible => responsible.externalId === resp.externalId || responsible.email === resp.email || responsible.phone === resp.phone)) {
			return;
		}
		setResponsibles([...responsibles, resp]);
	}

	function handleRemoveResponsible(index) {
		const newList = [...responsibles];
		newList.splice(index, 1);
		setResponsibles(newList);
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				urlLogo={urlLogo}
				tituloConsulta={props.client?.name || null}
				tituloCadastro="Cadastro de Clientes"
				icon={<BsPeople size={20} />}
				backRoute={"/consulta-clientes"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleClickEdit={handleClickEditButton}
					handleDelete={handleDelete}
					navigateCancelUrl="../consulta-clientes"
					askForPasswordOnDelete={true}
				>
					<div className="container-image-info-name">
						<UploadButton
							onFileChanged={(file) => setPhotoFile(file)}
							label="Importar Logo"
							disabled={props.type === "consulta"}
							currentFileBase64={currentPhotoFile}
						/>
						<div className="container-info-client">
							<div className="container-name-cpf">
								<div className="grid-2">
									<Input
										name={"nome"}
										id="nome"
										labelText={"Nome da Empresa *"}
										value={nome}
										onChange={({ target }) => setNome(target.value)}
										disabled={props.type === "consulta"}
										required={true}
									/>
									<Input
										name="cpf_cnpj"
										id="cpf_cnpj"
										labelText="CPF/CNPJ *"
										value={cpfOrCnpj}
										onChange={({ target }) => setCpfOrCnpj(target.value)}
										required
										disabled={props.type === "consulta"}
										showCpfCnpjMask={true}
									/>
								</div>
								<div className="grid-3">
									<Input
										name={"telefone"}
										id="telefone"
										labelText={"Telefone *"}
										value={telefone}
										onChange={({ target }) => setTelefone(target.value)}
										required={true}
										hidden={props.type === "consulta"}
										showPhoneMask={true}
										minLength={"15"}
										maxLength={"15"}
									/>
									<Input
										placeholder="exemplo@email.com"
										name={"mail"}
										id="mail"
										labelText={"E-mail *"}
										value={mail}
										onChange={({ target }) => setMail(target.value)}
										required={true}
										disabled={props.type === "consulta"}
									/>
									<Input
										name={"site"}
										id="site"
										labelText={"Site"}
										onChange={({ target }) => setSite(target.value)}
										value={site}
										hidden={props.type === "consulta"}
									/>
								</div>
								<div className="grid-2">
									<Select
										labelText="Status *"
										name="status"
										id="status"
										value={status}
										onChange={({ target }) => setStatus(target.value)}
										disabled={props.type === "consulta"}
										required={true}
										options={[
											{ value: -1, text: "Deletado" },
											{ value: -2, text: "Arquivado" },
											{ value: 0, text: "Disabilitado" },
											{ value: 1, text: "Habilitado" },
											{ value: 2, text: "Pendente" },
										]}
									/>
									<Input
										name={"observacao"}
										id="observacao"
										labelText={"Observações"}
										onChange={({ target }) => setObservacao(target.value)}
										value={observacao}
										hidden={props.type === "consulta"}
										textarea={true}
										rows={5}
									/>
								</div>
								<div className="grid-2">
									<Input
										name="primaryColor"
										id="primaryColor"
										type="color"
										labelText="Cor primária"
										value={primaryColor}
										onChange={({ target }) => setPrimaryColor(target.value)}
										disabled={props.formMode === "consulta"}
										required={false}
									/>
									<Input
										name="secondaryColor"
										id="secondaryColor"
										type="color"
										labelText="Cor secundária"
										value={secondaryColor}
										onChange={({ target }) => setSecondaryColor(target.value)}
										disabled={props.formMode === "consulta"}
										required={false}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="responsibles-container" style={{ width: '100%', marginBottom: '15px' }}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
							<h4 className="input-label" style={{ marginBottom: 0 }}>Responsáveis *</h4>
							<div className="container-buttons" style={{ width: '100%', flexDirection: 'row', justifyContent: 'end', marginTop: 0 }}>
								{props.type !== "consulta" && (
									<Button
										label="Adicionar"
										action="add"
										onClick={() => setShowRespModal(true)}
										className="button-link"
									/>
								)}
							</div>
						</div>
						<ResponsibleList
							responsibles={responsibles}
							onRemove={handleRemoveResponsible}
							disabled={props.type === "consulta"}
						/>
					</div>
					{/* Seção de Endereço */}
					<div className="address-section">
						<h3 className="muted-md">Endereço</h3>
						<Input
							name="cep"
							id="cep"
							labelText="CEP *"
							value={cep}
							maxLength="9"
							onChange={(e) => {
								const val = e.target.value;
								setCep(val);
								if (val.replace(/\D/g, "").length === 8) {
									handleCepBlur(val);
								}
							}}
							required={true}
							disabled={props.type === "consulta"}
							mask="CEP"
						/>
						<Input
							name="rua"
							id="rua"
							labelText="Rua *"
							value={rua}
							onChange={({ target }) => setRua(target.value)}
							required={true}
							disabled={props.type === "consulta"}
						/>
						<Input
							name="bairro"
							id="bairro"
							labelText="Bairro *"
							value={bairro}
							onChange={({ target }) => setBairro(target.value)}
							required={true}
							disabled={props.type === "consulta"}
						/>
						<Input
							name="numero"
							id="numero"
							labelText="Número *"
							value={numero}
							onChange={({ target }) => setNumero(target.value)}
							required={true}
							disabled={props.type === "consulta"}
						/>
						<Input
							name="complemento"
							id="complemento"
							labelText="Complemento"
							value={complemento}
							onChange={({ target }) => setComplemento(target.value)}
							disabled={props.type === "consulta"}
						/>
						<Input
							name="cidade"
							id="cidade"
							labelText="Cidade *"
							value={cidade}
							onChange={({ target }) => setCidade(target.value)}
							required={true}
							disabled={props.type === "consulta"}
						/>
						<Input
							name="uf"
							id="uf"
							labelText="UF *"
							value={uf}
							onChange={({ target }) => setUf(target.value)}
							required={true}
							disabled={props.type === "consulta"}
						/>
						<Input
							name="pais"
							id="pais"
							labelText="País *"
							value={pais}
							onChange={({ target }) => setPais(target.value)}
							required={true}
							disabled={props.type === "consulta"}
						/>
					</div>
					{/** Seção de ações permitidas */}
					{props.type !== "consulta" && (
						<div className="actions-section">
							<div className="politica-actions">
								<h3 className="bordered">
									<span style={{ marginRight: 5, display: 'inline-flex' }}>Permissionamento</span>
									<ToolTip
										tooltipVisible={true}
										tooltipText={"Ações para as quais o cliente pode criar políticas"}
									/>
								</h3>
								<Button
									onClick={() => setShowPermissions(!showPermissions)}
									label={showPermissions ? "Ocultar permissões" : "Ver permissões"}
									className={`button-white ${showPermissions ? "w-[180px]!" : "w-[140px]!"}`}
								/>
								{showPermissions && (
									<div className="politica-items-container">
										{actions?.length > 0 ? (
											<>
												<div className="politica-labels">
													<span>Fonte</span>
													<span>Serviço</span>
													<span>Escopo</span>
													<span>Ação</span>
												</div>
												{actions.map((action, idx) => (
													<div className="item-row" key={idx}>
														<Action
															owner={action.owner}
															service={action.service}
															scope={action.scope}
															action={action.action}
															onUpdateField={(value, field) => updateActionField(idx, field, value)}
														/>
														<button type="button" className="btn-delete-item" onClick={e => removeAction(idx)}><MdOutlineDelete size={18} /></button>
													</div>
												))}
											</>
										) : (
											<p className="empty-text">Nenhuma ação selecionada, essa organização não vai conseguir criar/editar nenhuma política.</p>
										)}
										<div className="container-buttons">
											<Button
												className="button-white"
												label={"Restaurar padrão"}
												onClick={defaultActions}
												icon={<BiReset />}
											/>
											<Button
												className={"button-white btn-add-item"}
												label={"Adicionar"}
												onClick={addAction}
											/>
											{actions?.length > 2 && (
												<Button
													className={"button-red"}
													label={"Remover todos"}
													action="delete"
													onClick={() => setActions([])}
												></Button>
											)}
										</div>
									</div>
								)}
							</div>
						</div>
					)}
				</Form>
			)
			}
			<ResponsibleModal
				isOpen={showRespModal}
				onClose={() => setShowRespModal(false)}
				onAdd={handleAddResponsible}
			/>
		</React.Fragment >
	);
}

export default FormClients;
